webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(12);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(8);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(3);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _LabelList = __webpack_require__(9);
	
	var _LabelList2 = _interopRequireDefault(_LabelList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    'label-list': _LabelList2.default
	  },
	  computed: {
	    fontSize: function fontSize() {
	      return this.width < 640 ? this.width / 640 * 1.3 : 1;
	    },
	    current: function current() {
	      return this.letters.map(function (letter) {
	        return letter.value.toUpperCase();
	      }).join('');
	    },
	    isLoved: function isLoved() {
	      return this.loveList.indexOf(this.current) > -1;
	    }
	  },
	  data: function data() {
	    return {
	      width: 0,
	      numLetters: 5,
	      loveList: [],
	      letters: [{
	        'value': 'H',
	        'lock': false
	      }, {
	        'value': 'E',
	        'lock': false
	      }, {
	        'value': 'L',
	        'lock': false
	      }, {
	        'value': 'L',
	        'lock': false
	      }, {
	        'value': 'O',
	        'lock': false
	      }]
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var storedLoveList = window.localStorage['blazr-love-list'],
	        loveList = storedLoveList ? JSON.parse(storedLoveList) : [];
	    loveList.map(function (loved) {
	      _this.loveList.push(loved);
	    });
	    window.onresize = this.onResize;
	    this.onResize();
	  },
	
	  methods: {
	    generate: function generate() {
	      var _this2 = this;
	
	      this.letters.map(function (letter, index) {
	        if (!letter.lock) {
	          letter.value = _this2.randomLetter();
	        }
	      });
	    },
	    toggleLock: function toggleLock(index) {
	      this.letters[index].lock = !this.letters[index].lock;
	    },
	    randomLetter: function randomLetter() {
	      return String.fromCharCode(Math.floor(Math.random() * 26 + 65));
	    },
	    love: function love() {
	      if (this.isLoved) return;
	      this.loveList.push(this.current);
	    },
	    onResize: function onResize() {
	      this.width = window.innerWidth;
	    }
	  },
	  watch: {
	    numLetters: function numLetters(value, oldValue) {
	      var i = 0;
	      this.letters = [];
	      while (i < value) {
	        this.$set(this.letters, i++, {
	          'value': this.randomLetter(),
	          'lock': false
	        });
	      }
	    },
	    loveList: function loveList(value, oldValue) {
	      window.localStorage.setItem('blazr-love-list', (0, _stringify2.default)(value));
	    }
	  }
	};

/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      selected: null
	    };
	  },
	
	  props: ['list'],
	  computed: {},
	  mounted: function mounted() {},
	
	  methods: {
	    clickHandler: function clickHandler(index) {
	      if (this.selected === index) {
	        this.list.splice(index, 1);
	      } else {
	        this.selected = index;
	      }
	    }
	  },
	  watch: {
	    list: function list() {
	      this.selected = null;
	    }
	  },
	  components: {}
	};

/***/ },
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 7 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(6)
	
	/* script */
	__vue_exports__ = __webpack_require__(1)
	
	/* template */
	var __vue_template__ = __webpack_require__(10)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(7)
	
	/* script */
	__vue_exports__ = __webpack_require__(2)
	
	/* template */
	var __vue_template__ = __webpack_require__(11)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 10 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;
	  return _vm._h('div', {
	    style: ({
	      'font-size': _vm.fontSize + 'px'
	    }),
	    attrs: {
	      "id": "app"
	    }
	  }, [_vm._h('div', {
	    staticClass: "global"
	  }, [_vm._h('div', {
	    staticClass: "tool"
	  }, [_vm._h('h1', {
	    staticClass: "title"
	  }, ["BLAZR"]), " ", _vm._h('p', ["Cherche un ", _vm._h('span', {
	    staticClass: "highlight"
	  }, ["blaze"]), " de ", _vm._h('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.numLetters),
	      expression: "numLetters",
	      modifiers: {
	        "number": true
	      }
	    }],
	    staticClass: "num-selection",
	    on: {
	      "change": function($event) {
	        _vm.numLetters = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return _vm._n(val)
	        })[0]
	      }
	    }
	  }, [_vm._l((9), function(index) {
	    return _vm._h('option', [_vm._s(index)])
	  })]), " " + _vm._s(_vm.numLetters > 1 ? 'lettres' : 'lettre')]), " ", _vm._h('div', {
	    staticClass: "letters-wrapper"
	  }, [_vm._h('div', {
	    staticClass: "letters"
	  }, [_vm._l((_vm.numLetters), function(letter) {
	    return _vm._h('div', {
	      staticClass: "letter-wrapper",
	      class: {
	        'lock': _vm.letters[letter - 1].lock
	      },
	      on: {
	        "click": function($event) {
	          _vm.toggleLock(letter - 1)
	        }
	      }
	    }, [_vm._h('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.letters[letter - 1].value),
	        expression: "letters[letter-1].value"
	      }],
	      staticClass: "letter",
	      attrs: {
	        "maxlength": "1"
	      },
	      domProps: {
	        "value": _vm._s(_vm.letters[letter - 1].value)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.letters[letter - 1].value = $event.target.value
	        }
	      }
	    })])
	  })]), " ", _vm._h('div', {
	    staticClass: "heart",
	    class: {
	      'loved': _vm.isLoved
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        $event.stopPropagation();
	        _vm.love($event)
	      }
	    }
	  }, ["❤"])]), " ", _vm._h('div', {
	    staticClass: "button",
	    on: {
	      "click": _vm.generate
	    }
	  }, ["Chercher"])]), " ", _vm._h('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loveList.length),
	      expression: "loveList.length"
	    }],
	    staticClass: "heart-title"
	  }, ["❤"]), " ", _vm._h('label-list', {
	    staticClass: "love",
	    attrs: {
	      "list": _vm.loveList
	    }
	  })])])
	},staticRenderFns: []}

/***/ },
/* 11 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;
	  return _vm._h('ul', {
	    staticClass: "label-list"
	  }, [_vm._l((_vm.list), function(label, index) {
	    return _vm._h('li', {
	      staticClass: "label",
	      class: {
	        'selected': _vm.selected === index
	      },
	      on: {
	        "click": function($event) {
	          _vm.clickHandler(index)
	        }
	      }
	    }, [_vm._s(label)])
	  })])
	},staticRenderFns: []}

/***/ }
]);


// WEBPACK FOOTER //
// js/app.5fc3c741cb9c5fdf2047.js